/* eslint-disable max-len */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.Butterfly = function (scene, animal) {
  this.scene = scene;
  this.animal = animal;
  this.speedH = 70; // 90
  this.direction = 1;
  this.padding = 15;
  this.maxX = this.scene.game.config.width - 130;
  this.tweenFloat = null;
  this.tweenAngle = null;
  this.angle = 5;
  this.frozen = false;
  this.deleted = false;
  return this;
};
const butterfly = EDC.Animations.Butterfly.prototype;

butterfly.start = function () {
  this.move();
};

butterfly.move = function () {
  this.movementHorizontalComplete();
  this.float();
  this.changeAngle();
};

butterfly.movementHorizontalComplete = function () {
  this.scene.physics.world.enable(this.animal, 0);
  this.animal.body.setVelocity(this.speedH * this.direction, 0).setBounce(1).setCollideWorldBounds(true);
  this.checkCollision();
};

butterfly.checkCollision = function () {
  if (!this.deleted) {
    if (this.animal.body.x > this.maxX) {
      this.animal.flipX = true;
      this.direction = -1;
      this.animal.body.setVelocity(this.speedH * this.direction, 0);
      this.scene.time.addEvent({ delay: 100, callback: this.checkCollision, callbackScope: this });
    } else if (this.animal.body.x < this.padding) {
      this.animal.flipX = false;
      this.direction = 1;
      this.animal.body.setVelocity(this.speedH * this.direction, 0);
      this.scene.time.addEvent({ delay: 100, callback: this.checkCollision, callbackScope: this });
    } else {
      this.scene.time.addEvent({ delay: 100, callback: this.checkCollision, callbackScope: this });
    }
  }
};

butterfly.float = function () {
  const randomY = 30 + Math.round(Math.random() * 60);
  const randomDuration = 800 + Math.round(Math.random() * 800);
  this.tweenFloat = this.scene.tweens.add({
    targets: this.animal,
    y: this.animal.y - randomY,
    duration: randomDuration,
    ease: 'Sine.easeInOut',
    yoyo: true,
    onComplete: this.float.bind(this),
  });
};

butterfly.changeAngle = function () {
  this.angle *= -1;
  this.tweenAngle = this.scene.tweens.add({
    targets: this.animal,
    angle: this.angle,
    duration: 1200,
    ease: 'Sine.easeInOut',
    onComplete: this.changeAngle.bind(this),
  });
};

// butterfly.changeSpeed = function () {
//   this.direction *= -1
//   this.animal.body.setVelocity(this.speedH * this.direction, 0)
// }

butterfly.stop = function () {
  this.frozen = true;
  this.animal.body.stop();
  this.tweenFloat.pause();
  this.tweenAngle.pause();
};

butterfly.resume = function () {
  if (this.frozen) {
    this.movementHorizontalComplete();
    this.tweenFloat.resume();
    this.tweenAngle.resume();
  }
};

butterfly.delete = function () {
  this.stop();
  this.deleted = true;
};
export default EDC.Animations.Butterfly;
